import React from "react";

function Map() {
  return (
    <section className="tc-map-style1">
      <div className="map-card wow zoomIn slow" data-wow-delay="0.2s">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.782241482429!2d77.0650149!3d28.455980000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1911213756a3%3A0x16ff197a62b6c74a!2sSS%20Architects%20%26%20Interiors!5e0!3m2!1sen!2sin!4v1782548241115!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          title="SS Architects & Interiors"
        />
      </div>
    </section>
  );
}

export default Map;